import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Kpi, Location, MetricByPeriods } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Location.Basic>> =>
	Http.get(baseUrl, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Location.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const retrieveFilters = (params?: Location.Filter.Basic): Promise<Entity[]> =>
	Http.get(`${baseUrl}/filters`, { params })

export const addLocation = (payload: Location.Request.Add): Promise<void> =>
	Http.post(`${baseUrl}/update-locations`, payload)

export const retrieveSelectedLocations = (): Promise<number> => Http.get(`${baseUrl}/count`)

export const retrieveKpiFilterOptions = (): Promise<Location.FilterOptions> =>
	Http.get(`${baseUrl}/with-categories`)

export const retrieveLocationOptions = (): Promise<Location.LocationFilter> =>
	Http.get(`${baseUrl}/options`)

export const getLocationMetricData = (
	params: TableUrlParams
): Promise<ListData<Kpi.Metric.ResponseBasic>> => Http.get(`${baseUrl}/by-metrics`, { params })

export const getLocationMetricMeasureData = (
	params: TableUrlParams
): Promise<ListData<MetricByPeriods.Basic>> =>
	Http.get(`${baseUrl}/by-metrics-measures`, { params })
